import * as React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"

const BlogSidebar = () => {
  const data = useStaticQuery(graphql`
    query BlogSidebarQuery {
      allShopifyArticle(sort: {fields: publishedAt, order: DESC}, limit: 10) {
        nodes {
          title
          handle
          publishedAt(formatString: "MMMM Do, YYYY")
          blog {
            handle
          }
        }
      }
    }
  `)

  const recentArticles = data.allShopifyArticle.nodes

  return(
    <div className="blog-sidebar">
      <h4 className="is-size-4 is-size-5-mobile my-4 has-text-danger is-uppercase">Recent Articles</h4>
      <ul>
        {recentArticles.map((article, i) => (
          <li key={i}>
            <Link to={`/blogs/${article.blog.handle}/${article.handle}/`} title={article.title}>{article.title}</Link>
            <div>{article.publishedAt}</div>
          </li>
        ))}
      </ul>
    </div>
  )

}

export default BlogSidebar